var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad5" },
    [
      _c("app-divider", { attrs: { label: "Dados do Título" } }),
      _c(
        "el-row",
        { staticClass: "pad5" },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v("Nome do beneficiário:")
              ]),
              _c("span", [
                _vm._v(
                  "  " +
                    _vm._s(_vm.filterNull(_vm.imovel.nomeBeneficiarioTitulo))
                )
              ])
            ])
          ]),
          _vm.hasFieldsExtras
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Nº do título:")
                  ]),
                  _c("span", [
                    _vm._v(
                      "  " + _vm._s(_vm.filterNull(_vm.imovel.numeroTitulo))
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm.hasFieldsExtras
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("Área:")]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(_vm.formatterNumber(_vm.imovel.areaTitulo)) +
                        " hectare(s)"
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm.hasFieldsExtras
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Data de expedição:")
                  ]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(_vm.formatDate(_vm.imovel.dataExpedicaoTitulo))
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm.hasFieldsExtras
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("Município:")]),
                  _vm.imovel.municipioTitulo
                    ? _c("span", [
                        _vm._v(
                          "  " +
                            _vm._s(
                              _vm.filterNull(_vm.imovel.municipioTitulo.nome)
                            )
                        )
                      ])
                    : _c("span", [_vm._v("  -")])
                ])
              ])
            : _vm._e(),
          _vm.hasFieldsExtras
            ? _c("el-col", { staticClass: "inputDiv", attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.labelsCadastro.imovel.lote))
                  ]),
                  _c("span", [
                    _vm._v("  " + _vm._s(_vm.filterNull(_vm.imovel.numeroLote)))
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb9eb4f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb9eb4f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resumo/AppResumoDadosTitulo.vue
// module id = null
// module chunks = 